import { useCreateSupportCase as useCoreCreateSupportCase } from '../core/hooks/use-create-support-case';
import { useKnowledgeForceCaseProvider } from '../providers/knowledge-force/use-knowledge-force-case-provider';

/** Select the case provider here so the form depends only on the support contract. */
export const useCreateSupportCase = () => useCoreCreateSupportCase(useKnowledgeForceCaseProvider());
